module.exports = __webpack_public_path__ + "img/spinner-blocking.5ebad0d8.png";